export default {"src":"/_next/static/media/goat-spins-message-instant-withdrawals.b12d57e9.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};